import { useCallback, useEffect, useState } from "react";
import { fetchBioFlowAccountStatus } from "src/api/bioflow";
import type { BioFlowAccountStatus } from "src/types/bioflow";

export function useBioFlowAccount() {
  const [account, setAccount] = useState<BioFlowAccountStatus | null>(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const status = await fetchBioFlowAccountStatus();
      setAccount(status);
      return status;
    } catch {
      setAccount(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return {
    account,
    loading,
    refresh,
    hasAccount: !!account?.exists,
    registered: !!account?.registered,
    onboardingComplete: !!account?.onboardingComplete,
  };
}
